import React from "react";
import { TemplatePaiementEchec } from '../../Templates/index';

// Mail comptabilité
const mailPaiement = "comptabilite@cgrm.com";
// URL de paiement
const pathToPaiement = "/cotisation";

const PaiementEchec = () => {
  
  return (
    <TemplatePaiementEchec
      mail={mailPaiement}
      pathToPaiement={pathToPaiement}
    />    
  );
};

export default React.memo(PaiementEchec);
